const Services = () => {
  return (
    <div className="programs-services">
      <div className="container">
        <div className="row">
          <div data-aos="zoom-in-right" className="services-img col-md-6 col-sm-12 col-xs-12">
            <img className="img-responsive" src="/assets/images/about2.jpg" alt="" />
          </div>
          <div data-aos="zoom-in-left" className="services-content col-md-6 col-sm-12 col-xs-12">
            <div className="planPrinciple">
              <h3
                style={{
                  width: "100%",
                  textAlign: "center",
                  backgroundColor: "#1c245b",
                  color: "white",
                  padding: "5px 0",
                }}
              >
                Our Services
              </h3>
            </div>
            <div>
              <h4 className="text-bold" style={{ marginBottom: "15px" }}>
                "From Entry Level to Advocate."
              </h4>
            </div>
            <div style={{ fontSize: "14px" }}>
              <ul style={{ listStyle: "inherit", marginLeft: "20px" }}>
                <li style={{ marginBottom: "10px", fontWeight: "bolder" }}>
                  CRPC
                  <ul style={{ listStyle: "initial", marginTop: "10px" }}>
                    <li style={{ marginBottom: "10px" }}>CPC</li>
                    <li style={{ marginBottom: "10px" }}>SR</li>
                    <li style={{ marginBottom: "10px" }}>Limitation</li>
                    <li style={{ marginBottom: "10px" }}>Evidence</li>
                    <li style={{ marginBottom: "10px" }}>Penal Code</li>
                    <li>Bar Rules and Order</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
